<template>
  <div class="content">
    <div :id="platform" class="carousel">
      <div v-if="items" class="movie carousel__container">
        <div
          v-for="item in items"
          :key="item.show.id"
          class="carousel-item"
          @click="seeDetail(item)"
        >
          <div class="date--item">
            <span v-if="!item.releaseDate2"
              >{{ item.releaseDate | date_single_updates }}
            </span>
            <span v-else> {{ item | date_multiple_updates }} </span>
          </div>
          <div class="movie--item" @click="goToShow(item)">
            <router-link :to="`/detail/${item.show.id}/${item.show.slug}/`">
              <figure class="movie-img">
                <img
                  v-if="item.show.imageUrl != null"
                  class="movie-img"
                  :src="item.show.imageUrl"
                  :alt="item.show.title"
                />
                <img v-else class="movie-no-img" src="/img/no_image.png" />
              </figure>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <button class="icon-carousel icon-prev" @click="prev">
      <font-awesome-icon icon="chevron-left" />
    </button>
    <button class="icon-carousel icon-next" @click="next">
      <font-awesome-icon icon="chevron-right" />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    items: { required: true },
    platform: { required: true },
  },
  data: () => ({
    carousel: { margin: 10 },
  }),

  methods: {
    goToShow(item) {
      this.$store.commit("EDIT_SHOW", item.show);
    },
    prev: function () {
      let a = document.getElementById(this.platform).scrollLeft;
      a -= 600;
      document
        .getElementById(this.platform)
        .scroll({ left: a, behavior: "smooth" });
    },
    next: function () {
      let a = document.getElementById(this.platform).scrollLeft;
      a += 600;
      document
        .getElementById(this.platform)
        .scroll({ left: a, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.movie {
  margin: 10px 0px;
  column-gap: 15px;
}
.movie--item {
  width: 130px;
  height: 187px;
  border-radius: 10px;
  cursor: pointer;
  background-color: #d5d5d5;

  margin: 10px 10px 0 10px;
}
.date--item {
  text-align: center;
  font-size: 0.9rem;
}
.movie-img {
  margin: 0;
  border-radius: 10px;
  width: 130px;
  height: 187px;
  object-fit: cover;
}

.movie-no-img {
  border-radius: 10px;
  width: 70%;
  object-fit: contain;
  margin: 20% 15%;
}

/* CAROUSEL */
.content {
  position: relative;
}
.carousel {
  overflow-x: scroll;
  width: 100%;
}

.carousel__container {
  transition: 450ms -webkit-transform;
  transition: 450ms transform;
  transition: 450ms transform, 450ms -webkit-transform;
  font-size: 0;
  white-space: nowrap;
  padding-bottom: 10px;
  margin-top: 15px;
}

.carousel__container:hover .carousel-item:hover {
  -webkit-transform: scale(1.01);
  transform: scale(1.01);
  opacity: 1;
}

.carousel-item {
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  display: inline-block;
  margin-right: 10px;
  font-size: 20px;
  cursor: pointer;
  transition: 450ms all;
  -webkit-transform-origin: center left;
  transform-origin: center left;
}

.carousel-item:hover ~ .carousel-item {
  -webkit-transform: translate3d(10px, 0, 0);
  transform: translate3d(10px, 0, 0);
}

.carousel-item__img {
  width: 95px;
  -o-object-fit: cover;
  object-fit: cover;
}

::-webkit-scrollbar {
  display: none;
}

.icon-carousel {
  background: rgba(0, 0, 0, 0);
  color: rgba(0, 0, 0, 0);
  border: 0px solid #9e9e9e;
  padding: 5px;
  margin-bottom: 10px;
  cursor: pointer;
  position: absolute;
  z-index: 1000;
  bottom: 10px;
  height: 215px;
  width: 40px;
}
.icon-carousel:hover {
  background: rgba(0, 0, 0, 0.9);
  color: white;
}

.icon-prev {
  left: 0px;
}

.icon-next {
  right: 0px;
}
/* FIN CAROUSEL */

@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1024px) and (max-width: 1264px) {
}
@media (min-width: 1020px) and (max-width: 1024px) {
}
@media (min-width: 960px) and (max-width: 1020px) {
}

@media (max-width: 600px) {
  .movie--item {
    width: 70%;
  }
}
</style>
